import { setSnackbarMessage } from './snackbarAction';
import { isEditingInProgress } from './AppAction';

export const messagesFetched = (items) => {
	return {
		type: 'MESSAGES_FETCHED',
		payload: items
	}
}

export const fileTypesFetched = (items) => {
	return {
		type: 'FILETYPES_FETCHED',
		payload: items
	}
}

export const setMessageReadNow = (int) => {
	return {
		type: 'SET_MESSAGE_READ',
		payload: int
	}
}

export const setMessageReadClientSide = (int) => {

	return {
		type : 'SET_MESSAGE_READ_CLIENT_SIDE',
		payload : int
	}
}


//-- This action fetches the messages based on a user ID
export const getMessages = (url, userId, userToken, showEditProgress, selectedRepresentativeUserId) => {
	let data = new FormData();
	data.append('userId', userId);
	data.append('userToken', userToken);
    data.append('selectedRepresentativeUserId', selectedRepresentativeUserId)
	return (dispatch) => {
		dispatch(isEditingInProgress('messages', true));
		fetch(url,
		{
			method: "POST",
			body: data
		})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}

			return response;
		})
		.then((response) => response.json())
		.then((items) => {

			if(!items.error_message) {
				dispatch(isEditingInProgress('messages', false));
				dispatch(messagesFetched(items))
			}else{
				dispatch(isEditingInProgress('messages', false));
				dispatch(setSnackbarMessage(items.error_message));
			}

		})
		.catch(() => {
			dispatch(isEditingInProgress('messages', false));
			dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan tijdens het laden van de berichten'));
		});
	};
}

export const getFileTypes = (url) => {
	return (dispatch) => {
		dispatch(isEditingInProgress('messages', true));
		fetch(url,
		{
			method: "POST"

		})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}

			return response;
		})
		.then((response) => response.json())
		.then((items) => {

			if(!items.error_message) {
				dispatch(isEditingInProgress('messages', false));
				dispatch(fileTypesFetched(items))
			}else{
				dispatch(isEditingInProgress('messages', false));
				dispatch(setSnackbarMessage(items.error_message));
			}

		})
		.catch(() => {
			dispatch(isEditingInProgress('messages', false));
			dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan tijdens het laden van de berichten'));
		});
	};
}

export const setMessageRead = (url, messageId, userId, setReadNow = false) => {
	let data = new FormData();
	data.append('messageId', messageId);
	data.append('user_id', userId);

	return (dispatch) => {
		dispatch(setMessageReadClientSide(messageId));
		fetch(url+'/api/messages/action/setMessageRead',
		{
			method: "POST",
			body: data
		})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}

			return response;
		})
		.then((response) => response.json())
		.then((items) => {

			dispatch(setMessageReadNow(messageId));

			//dispatch(megaDispatch(url));

		})
		.catch(() => {
			//dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan tijdens het lezen van het bericht'));
		});
	};
}



// WEBPACK FOOTER //
// ./src/redux/actions/messagesAction.js